/**
 * Wave 28: Country SEO i18n — Namibia 🇳🇦
 * + Gap filling for Cameroon, Senegal, Slovakia (ZH, JA, KO, SV, DA)
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE28: CountrySEOMap = {
  namibia: {
    fr: {
      title: 'Centre d\'appel Namibie | Externalisation BPO Windhoek | Call IT Dev',
      description: 'Externalisez votre centre d\'appel en Namibie : agents anglophones, fuseau CAT, CSAT 95%, dès 3$/h. Devis gratuit.',
      heroTitle: 'Centre d\'appel pour la Namibie — Support anglophone depuis Casablanca',
      heroSubtitle: 'Service client premium pour l\'Afrique australe à tarif nearshore. Opérationnel en 2-4 semaines.',
    },
    es: {
      title: 'Call Center Namibia | Externalización BPO Windhoek | Call IT Dev',
      description: 'Externalice su call center en Namibia: agentes anglófonos, zona CAT, CSAT 95%, desde 3$/h.',
      heroTitle: 'Call Center para Namibia — Soporte desde Casablanca',
      heroSubtitle: 'Servicio al cliente para el sur de África a precios nearshore.',
    },
    de: {
      title: 'Callcenter Namibia | BPO-Outsourcing Windhoek | Call IT Dev',
      description: 'Outsourcen Sie Ihr Callcenter nach Namibia: englischsprachige Agenten, CAT-Zone, 95% CSAT, ab 3$/h.',
      heroTitle: 'Callcenter für Namibia — Support aus Casablanca',
      heroSubtitle: 'Premium-Kundenservice für das südliche Afrika zu Nearshore-Preisen.',
    },
    ar: {
      title: 'مركز اتصال ناميبيا | تعهيد BPO ويندهوك | Call IT Dev',
      description: 'استعن بمصادر خارجية لمركز الاتصال في ناميبيا: وكلاء ناطقون بالإنجليزية، CSAT 95%، من 3$/ساعة.',
      heroTitle: 'مركز اتصال لناميبيا — دعم من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة لجنوب أفريقيا بأسعار نيرشور.',
    },
    it: {
      title: 'Call Center Namibia | Outsourcing BPO Windhoek | Call IT Dev',
      description: 'Esternalizza il tuo call center in Namibia: agenti anglofoni, fuso CAT, CSAT 95%, da 3$/h.',
      heroTitle: 'Call Center per la Namibia — Supporto da Casablanca',
      heroSubtitle: 'Servizio clienti per il Sud Africa a prezzi nearshore.',
    },
    pt: {
      title: 'Call Center Namíbia | Outsourcing BPO Windhoek | Call IT Dev',
      description: 'Terceirize seu call center na Namíbia: agentes anglófonos, fuso CAT, CSAT 95%, a partir de 3$/h.',
      heroTitle: 'Call Center para a Namíbia — Suporte a partir de Casablanca',
      heroSubtitle: 'Atendimento ao cliente para o Sul da África a preços nearshore.',
    },
    nl: {
      title: 'Callcenter Namibië | BPO Outsourcing Windhoek | Call IT Dev',
      description: 'Outsource uw callcenter naar Namibië: Engelstalige agenten, CAT-zone, 95% CSAT, vanaf $3/u.',
      heroTitle: 'Callcenter voor Namibië — Support vanuit Casablanca',
      heroSubtitle: 'Klantenservice voor Zuidelijk Afrika tegen nearshore-tarieven.',
    },
    pl: {
      title: 'Call Center Namibia | Outsourcing BPO Windhoek | Call IT Dev',
      description: 'Outsourcing call center do Namibii: anglojęzyczni agenci, strefa CAT, CSAT 95%, od 3$/h.',
      heroTitle: 'Call Center dla Namibii — Wsparcie z Casablanki',
      heroSubtitle: 'Obsługa klienta dla Afryki Południowej w cenach nearshore.',
    },
    ru: {
      title: 'Колл-центр Намибия | BPO-аутсорсинг Виндхук | Call IT Dev',
      description: 'Аутсорсинг колл-центра в Намибии: англоязычные операторы, зона CAT, CSAT 95%, от $3/ч.',
      heroTitle: 'Колл-центр для Намибии — поддержка из Касабланки',
      heroSubtitle: 'Обслуживание клиентов для юга Африки по ценам nearshore.',
    },
    tr: {
      title: 'Çağrı Merkezi Namibya | BPO Outsourcing Windhoek | Call IT Dev',
      description: 'Namibya çağrı merkezinizi dışarıdan temin edin: İngilizce konuşan temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Namibya İçin Çağrı Merkezi — Kazablanka\'dan Destek',
      heroSubtitle: 'Güney Afrika için nearshore fiyatlarla müşteri hizmetleri.',
    },
    zh: {
      title: '纳米比亚呼叫中心 | BPO外包温得和克 | Call IT Dev',
      description: '外包纳米比亚呼叫中心：英语客服，CAT时区，CSAT 95%，每小时3美元起。',
      heroTitle: '纳米比亚呼叫中心 — 来自卡萨布兰卡的支持',
      heroSubtitle: '以近岸价格为南部非洲提供优质客户服务。',
    },
    ja: {
      title: 'コールセンター ナミビア | BPOアウトソーシング ウィントフック | Call IT Dev',
      description: 'ナミビアのコールセンターをアウトソーシング：英語対応、CATタイムゾーン、CSAT 95%、時給3ドルから。',
      heroTitle: 'ナミビア向けコールセンター — カサブランカからのサポート',
      heroSubtitle: 'ニアショア価格で南部アフリカ向けカスタマーサービス。',
    },
    ko: {
      title: '콜센터 나미비아 | BPO 아웃소싱 빈트후크 | Call IT Dev',
      description: '나미비아 콜센터 아웃소싱: 영어 상담원, CAT 시간대, CSAT 95%, 시간당 $3부터.',
      heroTitle: '나미비아 콜센터 — 카사블랑카에서 지원',
      heroSubtitle: '니어쇼어 가격으로 남부 아프리카 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Namibia | BPO Outsourcing Windhoek | Call IT Dev',
      description: 'Outsourca ditt callcenter till Namibia: engelsktalande agenter, CAT-tidszon, 95% CSAT, från $3/h.',
      heroTitle: 'Callcenter för Namibia — Support från Casablanca',
      heroSubtitle: 'Kundservice för södra Afrika till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Namibia | BPO Outsourcing Windhoek | Call IT Dev',
      description: 'Outsource dit callcenter til Namibia: engelsktalende agenter, CAT-tidszone, 95% CSAT, fra $3/t.',
      heroTitle: 'Callcenter for Namibia — Support fra Casablanca',
      heroSubtitle: 'Kundeservice for det sydlige Afrika til nearshore-priser.',
    },
  },

  // Gap fill: Cameroon missing langs
  cameroon: {
    zh: {
      title: '喀麦隆呼叫中心 | BPO外包杜阿拉 | Call IT Dev',
      description: '外包喀麦隆呼叫中心：法语/英语双语客服，CSAT 95%，每小时3美元起。',
      heroTitle: '喀麦隆呼叫中心 — 来自卡萨布兰卡的支持',
      heroSubtitle: '以近岸价格为中非提供优质双语客户服务。',
    },
    ja: {
      title: 'コールセンター カメルーン | BPOアウトソーシング | Call IT Dev',
      description: 'カメルーンのコールセンター：仏英バイリンガル対応、CSAT 95%、時給3ドルから。',
      heroTitle: 'カメルーン向けコールセンター',
      heroSubtitle: 'ニアショア価格で中央アフリカ向けバイリンガルサービス。',
    },
    ko: {
      title: '콜센터 카메룬 | BPO 아웃소싱 | Call IT Dev',
      description: '카메룬 콜센터: 불어/영어 이중언어, CSAT 95%, 시간당 $3부터.',
      heroTitle: '카메룬 콜센터',
      heroSubtitle: '니어쇼어 가격으로 중앙 아프리카 이중언어 서비스.',
    },
    sv: {
      title: 'Callcenter Kamerun | BPO Outsourcing | Call IT Dev',
      description: 'Outsourca till Kamerun: tvåspråkiga agenter (franska/engelska), 95% CSAT, från $3/h.',
      heroTitle: 'Callcenter för Kamerun',
      heroSubtitle: 'Tvåspråkig kundservice för Centralafrika till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Cameroun | BPO Outsourcing | Call IT Dev',
      description: 'Outsource til Cameroun: tosprogede agenter (fransk/engelsk), 95% CSAT, fra $3/t.',
      heroTitle: 'Callcenter for Cameroun',
      heroSubtitle: 'Tosproget kundeservice for Centralafrika til nearshore-priser.',
    },
  },

  // Gap fill: Senegal missing langs
  senegal: {
    zh: {
      title: '塞内加尔呼叫中心 | BPO外包达喀尔 | Call IT Dev',
      description: '外包塞内加尔呼叫中心：法语客服，CSAT 95%，每小时3美元起。',
      heroTitle: '塞内加尔呼叫中心 — 来自卡萨布兰卡的支持',
      heroSubtitle: '以近岸价格为西非提供法语客户服务。',
    },
    ja: {
      title: 'コールセンター セネガル | BPOアウトソーシング | Call IT Dev',
      description: 'セネガルのコールセンター：フランス語対応、CSAT 95%、時給3ドルから。',
      heroTitle: 'セネガル向けコールセンター',
      heroSubtitle: 'ニアショア価格で西アフリカ向けフランス語サービス。',
    },
    ko: {
      title: '콜센터 세네갈 | BPO 아웃소싱 | Call IT Dev',
      description: '세네갈 콜센터: 불어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '세네갈 콜센터',
      heroSubtitle: '니어쇼어 가격으로 서아프리카 불어 서비스.',
    },
    sv: {
      title: 'Callcenter Senegal | BPO Outsourcing | Call IT Dev',
      description: 'Outsourca till Senegal: fransktalande agenter, 95% CSAT, från $3/h.',
      heroTitle: 'Callcenter för Senegal',
      heroSubtitle: 'Franskspråkig kundservice för Västafrika till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Senegal | BPO Outsourcing | Call IT Dev',
      description: 'Outsource til Senegal: fransktalende agenter, 95% CSAT, fra $3/t.',
      heroTitle: 'Callcenter for Senegal',
      heroSubtitle: 'Fransktalende kundeservice for Vestafrika til nearshore-priser.',
    },
  },

  // Gap fill: Slovakia missing langs
  slovakia: {
    zh: {
      title: '斯洛伐克呼叫中心 | BPO外包布拉迪斯拉发 | Call IT Dev',
      description: '外包斯洛伐克呼叫中心：多语言客服，CET时区，CSAT 95%，每小时3美元起。',
      heroTitle: '斯洛伐克呼叫中心 — 来自卡萨布兰卡的支持',
      heroSubtitle: '以近岸价格为中欧提供优质客户服务。',
    },
    ja: {
      title: 'コールセンター スロバキア | BPOアウトソーシング | Call IT Dev',
      description: 'スロバキアのコールセンター：多言語対応、CETタイムゾーン、CSAT 95%、時給3ドルから。',
      heroTitle: 'スロバキア向けコールセンター',
      heroSubtitle: 'ニアショア価格で中央ヨーロッパ向けサービス。',
    },
    ko: {
      title: '콜센터 슬로바키아 | BPO 아웃소싱 | Call IT Dev',
      description: '슬로바키아 콜센터: 다국어 상담원, CET 시간대, CSAT 95%, 시간당 $3부터.',
      heroTitle: '슬로바키아 콜센터',
      heroSubtitle: '니어쇼어 가격으로 중앙 유럽 서비스.',
    },
    sv: {
      title: 'Callcenter Slovakien | BPO Outsourcing | Call IT Dev',
      description: 'Outsourca till Slovakien: flerspråkiga agenter, CET-tidszon, 95% CSAT, från $3/h.',
      heroTitle: 'Callcenter för Slovakien',
      heroSubtitle: 'Kundservice för Centraleuropa till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Slovakiet | BPO Outsourcing | Call IT Dev',
      description: 'Outsource til Slovakiet: flersprogede agenter, CET-tidszone, 95% CSAT, fra $3/t.',
      heroTitle: 'Callcenter for Slovakiet',
      heroSubtitle: 'Kundeservice for Centraleuropa til nearshore-priser.',
    },
  },
};
